import { ApolloClient } from "@apollo/client";
import { EstadisticasDsKeyDtSource } from "../../bussines/dataSources/EstadisticasDsKeyDtSource";
import { Recurso } from "lib.common/dist/CleanArch";
import { DataLlave, EstadisticasLlave, EstadoLlaveAnual, ResumenLlaveByClienteProductoUsuario } from "../../bussines/entities/EstadisticasLlave.entity";
import { FechaParams, GetEstadoLlavesAnualParams } from "../../utils/params/EstadisticasDsKey.params";
import { format } from "date-fns";
import { getEstadisticasLlavesGql, getEstadoLlavesAnualGql, getLlavesAnuladasMesGql, getLlavesPorExpirarGql, getResumenLlavesGql } from "../../utils/gql/estadisticasDsKeyGql";
import { gqlErrorsMapperRecurso } from 'lib.front/dist/common/funErrorMappers';
import { ErrExterno } from "lib.common/dist/errorHandler";

export class EstadisticasDsKeyDtSourceImplGql implements EstadisticasDsKeyDtSource {
    private apolloClient: ApolloClient<object>;
    constructor(ApolloClient: ApolloClient<object>) {
        this.apolloClient = ApolloClient;
    }

    async getEstadisticasLlaves(input: FechaParams): Promise<Recurso<EstadisticasLlave>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            const variables = {
                fecha: fechaFormateada
            };
            const response = await this.apolloClient.query({
                variables,
                query: getEstadisticasLlavesGql
            });
            const errorRecurso = gqlErrorsMapperRecurso<EstadisticasLlave>(response.errors);
            return errorRecurso ?? Recurso.fromData<EstadisticasLlave>(response.data.estadisticasLlaves[0]);
        } catch (error) {
            return Recurso.fromError<EstadisticasLlave>(new ErrExterno(error as Error));
        }
    }

    async getLlavesAnuladasMes(input: FechaParams): Promise<Recurso<DataLlave[]>> {
        try {
            const anio = input.fecha.getFullYear();
            const mes = input.fecha.getMonth();
            const variables = {
                anio: anio,
                mes: mes
            };
            const response = await this.apolloClient.query({
                variables,
                query: getLlavesAnuladasMesGql
            });
            const errorRecurso = gqlErrorsMapperRecurso<DataLlave[]>(response.errors);
            return errorRecurso ?? Recurso.fromData<DataLlave[]>(response.data.llavesAnuladasMes);
        } catch (error) {
            return Recurso.fromError<DataLlave[]>(new ErrExterno(error as Error));
        }
    }

    async getLlavesPorExpirar(): Promise<Recurso<DataLlave[]>> {
        try {
            const response = await this.apolloClient.query({
                query: getLlavesPorExpirarGql
            });
            const errorRecurso = gqlErrorsMapperRecurso<DataLlave[]>(response.errors);
            return errorRecurso ?? Recurso.fromData<DataLlave[]>(response.data.llavesPorExpirar);
        } catch (error) {
            return Recurso.fromError<DataLlave[]>(new ErrExterno(error as Error));
        }
    }

    async getEstadoLlavesAnual(input: GetEstadoLlavesAnualParams): Promise<Recurso<EstadoLlaveAnual[]>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            const variables = {
                fecha: fechaFormateada,
                codProducto: input.codProducto ?? null
            };
            const response = await this.apolloClient.query({
                variables,
                query: getEstadoLlavesAnualGql
            });
            const errorRecurso = gqlErrorsMapperRecurso<EstadoLlaveAnual[]>(response.errors);
            return errorRecurso ?? Recurso.fromData<EstadoLlaveAnual[]>(response.data.estadoLlavesAnual);
        } catch (error) {
            return Recurso.fromError<EstadoLlaveAnual[]>(new ErrExterno(error as Error));
        }
    }

    async getResumenLlaves(input: FechaParams): Promise<Recurso<ResumenLlaveByClienteProductoUsuario[]>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            const variables = {
                fecha: fechaFormateada
            };
            const response = await this.apolloClient.query({
                variables,
                query: getResumenLlavesGql
            });
            const errorRecurso = gqlErrorsMapperRecurso<ResumenLlaveByClienteProductoUsuario[]>(response.errors);
            return errorRecurso ?? Recurso.fromData<ResumenLlaveByClienteProductoUsuario[]>(response.data.resumenLlaves);
        } catch (error) {
            return Recurso.fromError<ResumenLlaveByClienteProductoUsuario[]>(new ErrExterno(error as Error));
        }
    }
}